<template>
    <div class="actions" v-click-away="hideActions">
        <div class="actions-menu" v-show="actionsShown">
            <slot></slot>
        </div>

        <button class="btn-primary muted" type="button" :data-open="actionsShown"
                @click="actionsShown = !actionsShown">
            <ChevronUpIcon class="h-6 w-6 inline" />
            Actions
        </button>
    </div>
</template>

<script>
    import {ChevronUpIcon} from "@heroicons/vue/24/solid"

    export default {
        components: {
            ChevronUpIcon,
        },
        props: {
            title: {
                type: String,
                default: 'Actions',
            },
        },
        data() {
            return {
                actionsShown: false,
            }
        },
        methods: {
            /**
             * Hide the actions box.
             *
             * @return {void}
             */
            hideActions() {
                this.actionsShown = false
            },
        },
    }
</script>
